import { useQuery } from "@tanstack/react-query";

import { APIError, getPost } from "@/adapters/api";
import type { Post } from "@/features/feed/types.ts";
import { toPost } from "@/features/feed/utils/map.ts";

export function usePost(postId: string | undefined) {
	return useQuery({
		queryKey: ["post", postId],
		enabled: !!postId,
		queryFn: async (): Promise<Post> => {
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			return toPost(await getPost(postId!));
		},
		staleTime: 30_000,
		retry: (failureCount, error) => {
			if (error instanceof APIError && error.apiError.code === "not-found") {
				return false;
			}
			return failureCount < 3;
		},
	});
}
